export const getAuth = (state) => state.auth.isAuth;

export const getName = (state) => state.auth.user.name;

export const stateLogin = (state) => state.auth;
